import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import props from './attrs/props'

import { Cropper } from 'vue-advanced-cropper'

export default {
    name: 'ChangeProfilePicture',
    computed,
    data,
    methods,
    props,
    components: {
        Cropper
    }
}
